<mat-icon #tooltip="matTooltip"
          (click)="prevent($event, tooltip)"
          matTooltipPosition="above"
          matTooltipClass="form-descriptor-tooltip"
          [class.form-descriptor]="(customRgPage$ | async) === 'freeway'"
          [matTooltip]="message">
  {{ (customRgPage$ | async) !== 'freeway' ? 'help' : 'help_outline'}}
</mat-icon>
